// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jt-6";
export var emphasizeQuantity = "_jt-3";
export var flatBottomCorners = "_jt-5";
export var productImage = "_jt-0";
export var quantityContainer = "_jt-2";
export var tooltip = "_jt-1";
export var wrapAndEllipsesOverflow = "_jt-4";